// Logo ==============================================
import ingetLogo from '@/assets/pics/inget.png'
import ingetFavicon from '@/assets/pics/inget.svg'
import pipsLogo from '@/assets/pics/logo.svg'
// Logo ==============================================
// Favicon ===========================================
import pipsFavicon from '@/assets/pics/pipsFavicon.png'
// Favicon ===========================================

export const getLogoByHost = () => {
  const hostname = window.location.hostname

  if (hostname.includes('pips.by') || hostname === 'localhost') {
    return pipsLogo
  }
  if (hostname.includes('inget.by')) {
    return ingetLogo
  }

  return pipsLogo
}

export const getFaviconByHost = () => {
  const hostname = window.location.hostname

  if (hostname.includes('pips.by') || hostname === 'localhost') {
    return pipsFavicon
  }
  if (hostname.includes('inget.by')) {
    return ingetFavicon
  }

  return pipsFavicon
}

export const getTitleByHost = () => {
  const hostname = window.location.hostname

  if (hostname.includes('pips.by') || hostname === 'localhost') {
    return 'PIPS'
  }
  if (hostname.includes('inget.by')) {
    return 'INGET'
  }

  return 'PIPS'
}

// import pipsLogo from '@/assets/pics/Transparent_christmas_PIPS_Logo_3149x1199.avif'
// import ingetLogo from '@/assets/pics/Transparent_christmas_INGET_Logo_1740x610.svg'

export const isTestHost = (hostname: string = window.location.hostname) =>
  hostname.startsWith('test.')
